// import { I_SearchFilter } from '../../interfaces/search';

// TODO: TypeScript 問題 (I_SearchFilter)
export const getFilterCount = (FilterData: any) => {
    if (!FilterData) return 0;

    const count = Object.keys(FilterData).reduce((acc, cur) => {
        if (cur === 'dpTimes') return acc;
        if (cur === 'departureTime' || cur === 'arrivalTime') return acc;

        if (cur === 'seqAirport') {
            let seqAirCount = 0;
            FilterData.seqAirport.forEach((seq: any) => {
                seqAirCount += seq.departure.length;
                seqAirCount += seq.arrival.length;
            });
            return acc + seqAirCount;
        }

        return acc + FilterData[cur].length;
    }, 0);

    return count;
};
